.section {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin: 1rem 0;
  padding: 0.75rem;
  border: 1px solid var(--border);
  border-radius: 0.5rem;
}

.title {
  margin: 0;
  font-size: 1.125rem;
}

.dialog {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 0.75rem;
  border: 1px solid var(--border);
  border-radius: 0.5rem;
  background: var(--surface-raised);
}

.subtitle {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
}

.fieldset {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin: 0;
  padding: 0;
  border: 0;
}

.legend {
  margin-bottom: 0.25rem;
  font-weight: 600;
}

.select {
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 1px solid var(--border);
  border-radius: 0.375rem;
  background: var(--surface-raised);
  color: var(--text);
  font: inherit;
}

.actions {
  display: flex;
  gap: 0.5rem;
}

.refusal {
  margin: 0;
  font-weight: 600;
  color: var(--danger-text);
}

.warning {
  margin: 0;
  font-weight: 600;
}

.copy {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.label {
  font-weight: 600;
}

.copyRow {
  display: flex;
  gap: 0.5rem;
}

.url {
  flex: 1;
  min-width: 0;
  padding: 0.5rem 0.75rem;
  border: 1px solid var(--border);
  border-radius: 0.375rem;
  background: var(--surface-raised);
  color: var(--text);
  font: inherit;
}

.select:focus-visible,
.url:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}

.notice {
  min-height: 1.5rem;
}

.list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem 1rem;
}

.hint {
  margin: 0;
  color: var(--text-muted);
}

.form {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
